import React from 'react';

import HeaderContainer from 'containers/HeaderContainer';
import OrderListContainer from 'containers/OrderListContainer';
import SessionStore from 'stores/SessionStore';

import AppConstants from 'AppConstants';
import Footer from 'views/Footer';

class MyOrdersPage extends React.Component {
	render() {

		return (
				<div id="myOrdersPage">
					<HeaderContainer />

					<div className="mainContainer">
						<OrderListContainer session={SessionStore.getCurrentSession()} showPaymentOption={true} showProductInfo={true} />
					</div>
					

					<div style={{padding: '10px', textAlign: 'right'}}>
						<small>To cancel any active orders, please call us at <i style={{color: "#f8941c"}} className="fa fa-phone-square" aria-hidden="true"></i> {AppConstants.CONTACT_NUMBER} or WhatsApp at <i style={{color: "green"}} className="fa fa-whatsapp" aria-hidden="true"></i> {AppConstants.WHATS_APP}</small>
					</div>

					<Footer />
				</div>
			);
		
	}
}


export default MyOrdersPage;


// WEBPACK FOOTER //
// ./src/pages/MyOrdersPage.js